export const toDate3mf = d => (d ? d.toISOString().substring(0, 10) : '')
